import useSWR, { SWRResponse } from 'swr';
import { QueryArguments, QueryResponse } from '../../types';
import { convertQueryArguments, fetcher } from '../../utils';

export const useSanityIssuerById = (props: Partial<QueryArguments>): SWRResponse<QueryResponse | null, any, any> => {
  const swrArguments = convertQueryArguments(props);
  const response = useSWR(swrArguments, fetcher);
  return response;
};
